<template>
    <div>
        <Header title="测评用户" memo="管理测评用户信息"></Header>
        <a-divider />
        <div class="flex-x-space-between" :style="{ marginTop: '16px' }">
            <div></div>
            <div>
                <a-form-model layout="inline" :model="query">
                    <a-form-model-item>
                        <a-select show-search v-model="query.unit" :filter-option="false" :not-found-content="null" @search="doLoadUnit" @change="execQuery" :style="{ width: '100px' }">
                            <a-select-option value="">
                                所有机构
                            </a-select-option>
                            <a-select-option v-for="item in units" :key="item.id" :value="item.id" :label="item.name">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-select show-search v-model="query.oid" :filter-option="false" :not-found-content="null" @search="doLoadOrg" @change="execQuery" :style="{ width: '100px' }">
                            <a-select-option value="">
                                所有组织
                            </a-select-option>
                            <a-select-option v-for="item in orgs" :key="item.id" :value="item.id" :label="item.name">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-input v-model="query.id" placeholder="用户账号" @pressEnter="execQuery" :style="{ width: '100px' }">
                            <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
                        </a-input>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-input v-model="query.name" placeholder="用户名称" @pressEnter="execQuery" :style="{ width: '100px' }">
                            <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
                        </a-input>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-input v-model="query.mob" placeholder="用户手机" @pressEnter="execQuery" :style="{ width: '100px' }">
                            <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
                        </a-input>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-button icon="search" @click="execQuery">
                            查询
                        </a-button>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-button icon="retweet" @click="execReload">
                            刷新
                        </a-button>
                    </a-form-model-item>
                </a-form-model>
            </div>
        </div>
        <a-divider />
        <a-table :style="{ marginTop: '16px' }" :row-key="record => record.id" :data-source="datas" :loading="loading" bordered :pagination="false">
            <a-table-column key="id" ellipsis>
                <span slot="title">用户信息</span>
                <template slot-scope="text, record">
                    <a-popover placement="top">
                        <template slot="content">
                            <p>
                                用户账号：
                                <span>{{ record.id }}</span>
                            </p>
                            <p>
                                用户姓名：
                                <span>{{ record.name }}</span>
                            </p>
                            <p>
                                身份证号：
                                <span>{{ record.idno }}</span>
                            </p>
                            <p>
                                联系电话：
                                <span>{{ record.mob }}</span>
                            </p>
                            <p>
                                用户分组：
                                <span>{{ record.org.name }}</span>
                            </p>
                            <p>
                                出生日期：
                                <span>{{ record.bir }}</span>
                            </p>
                            <p>
                                性别：
                                <span>{{ record.gender === 'M' ? '男' : '女' }}</span>
                            </p>
                            <p>
                                训练师：
                                <span>{{ record.cta }}</span>
                            </p>
                        </template>
                        <template slot="title">
                            <span>用户信息</span>
                        </template>
                        <span>{{ record.name }} [{{ record.id }}] / {{ record.gender === 'M' ? '男' : '女' }} / {{ record.mob }} / {{ record.cta }} / {{ record.org.name }}</span>
                    </a-popover>
                </template>
            </a-table-column>
            <a-table-column key="device" ellipsis width="300px">
                <span slot="title">当前设备</span>
                <template slot-scope="text, record">
                    <a-popover placement="top" v-if="record.device.id">
                        <template slot="content">
                            <p>
                                编号：
                                <span>{{ record.device.sno }}</span>
                            </p>
                            <p>
                                名称：
                                <span>{{ record.device.name }}</span>
                            </p>
                            <p>
                                时间：
                                <span>{{ record.device.bind }}</span>
                            </p>
                        </template>
                        <template slot="title">
                            <span>设备信息</span>
                        </template>
                        <template>[ {{ record.device.sno }} ] {{ record.device.name }}</template>
                    </a-popover>
                    <span v-else>
                        未绑定设备
                    </span>
                </template>
            </a-table-column>
            <a-table-column key="testing" ellipsis width="200px">
                <span slot="title">当前测评</span>
                <template slot-scope="text, record">
                    <a-popover placement="top" v-if="record.testing.id">
                        <template slot="content">
                            <p>
                                编号：
                                <span>{{ record.testing.id }}</span>
                            </p>
                            <p>
                                状态：
                                <span>{{ record.testing.state | testingState }}</span>
                            </p>
                            <p>
                                类型：
                                <span>{{ record.testing.type === 'Exam' ? '测验模式' : '训练模式' }}</span>
                            </p>
                            <p>
                                进度：
                                <span>{{ record.testing.step }}</span>
                            </p>
                        </template>
                        <template slot="title">
                            <span>测评信息</span>
                        </template>
                        <template>{{ record.testing.type === 'Exam' ? '测验' : '训练' }} [{{ record.testing.step }}]</template>
                    </a-popover>
                    <a-tag color="#2db7f5" v-else>暂无测评</a-tag>
                </template>
            </a-table-column>
            <a-table-column key="unit" ellipsis width="200px">
                <span slot="title">归属机构</span>
                <template slot-scope="text, record">
                    <span>{{ record.unit.name }}</span>
                </template>
            </a-table-column>
            <a-table-column key="create" ellipsis width="200px">
                <span slot="title">添加人员</span>
                <template slot-scope="text, record">
                    <a-popover placement="top">
                        <template slot="content">
                            <p>
                                编号：
                                <span>{{ record.create.id }}</span>
                            </p>
                            <p>
                                时间：
                                <span>{{ record.create.time }}</span>
                            </p>
                        </template>
                        <template slot="title">
                            <span>添加人员</span>
                        </template>
                        <span>{{ record.create.name }}</span>
                    </a-popover>
                </template>
            </a-table-column>
        </a-table>

        <a-pagination
            :style="{ marginTop: '15px' }"
            :total="pager.rows"
            :current="query.page"
            :show-total="total => `共计 ${total} 条数据`"
            show-quick-jumper
            show-less-items
            show-size-changer
            hide-on-single-page
            :page-size.sync="query.size"
            :page-size-options="['10', '25', '50', '100']"
            @change="onChangePage"
            @showSizeChange="onChangeSize"
        />
    </div>
</template>

<script>
export default {
    name: 'AtePlatTester',

    computed: {
        loading() {
            return this.$store.state.Loading.flag && !this.$store.state.Loading.full
        }
    },
    data() {
        return {
            units: [],
            orgs: [],
            devices: [],
            query: {
                page: 1,
                size: 10,
                time: 0,
                unit: '',
                oid: '',
                id: '',
                name: '',
                mob: ''
            },
            datas: [],
            pager: {
                rows: 0,
                pnum: 1,
                pnow: 1,
                time: 0
            }
        }
    },
    filters: {
        testingState: value => {
            switch (value) {
                case 'Wait':
                    return '未开始'
                case 'Run':
                    return '进行中'
                case 'Pause':
                    return '暂停中'
                case 'Finish':
                    return '已完成'
                case 'Abort':
                    return '已中止'
            }
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['云测评', '测评用户'])
        this.doLoadOrg()
        this.doLoadDevice()
        this.doLoadUnit()
        this.doLoad()
    },
    methods: {
        doLoadUnit(name) {
            this.$http
                .get('/sys/data/user/unit', {
                    params: {
                        size: 20,
                        name: name || ''
                    },
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    this.units = result.datas
                })
        },
        doLoadDevice(name) {
            this.$http
                .get('/cts/ate/device/mgr/query', {
                    params: {
                        state: 'Idle',
                        size: 20,
                        name: name || ''
                    },
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    this.devices = result.datas
                })
        },
        doLoadOrg(name) {
            this.$http
                .get('/cts/ate/tester/org/query', {
                    params: {
                        size: 20,
                        name: name || ''
                    },
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    this.orgs = result.datas
                })
        },
        doLoad() {
            this.$http
                .get('/cts/ate/tester/info/list', {
                    params: this.query,
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    if (result.data.pnow === 1) {
                        this.query.time = result.data.time
                    }
                    this.pager = result.data
                    this.datas = result.datas
                })
        },

        onSelectChange(selectedRowKeys, selectedRows) {
            this.selRows = selectedRows
        },
        onChangePage(page) {
            this.query.page = page
            this.doLoad()
        },
        onChangeSize(page, size) {
            this.query.size = size
            this.query.page = 1
            this.doLoad()
        },
        execQuery() {
            this.query.page = 1
            this.doLoad()
        },
        execReload() {
            this.query = {
                page: 1,
                size: 10,
                time: 0,
                unit: '',
                oid: '',
                id: '',
                name: '',
                mob: ''
            }
            this.doLoad()
        }
    }
}
</script>
